import { Link } from "react-router-dom";
import Badge from "../ui/Badge";

function AppCard({ app }) {
  return (
    <article className="glass-card app-card">
      <div className="card-top">
        <div className="icon-badge">{app.name.slice(0, 2).toUpperCase()}</div>
        <div className="badge-row">
          <Badge tone="accent">{app.status}</Badge>
          <Badge>{app.category}</Badge>
        </div>
      </div>

      <div className="card-copy">
        <h3>{app.name}</h3>
        <p>{app.summary}</p>
      </div>

      <div className="meta-row">
        {app.platform.map((item) => (
          <Badge key={item}>{item}</Badge>
        ))}
      </div>

      <div className="tag-row">
        {app.tags.map((item) => (
          <span key={item} className="tag-pill">
            {item}
          </span>
        ))}
      </div>

      <div className="card-actions">
        <Link className="button button-secondary" to={`/myappshop/${app.slug}`}>
          Detayi Gor
        </Link>
        <a
          className="button button-ghost"
          href={app.demoUrl}
          target="_blank"
          rel="noreferrer"
        >
          Demo
        </a>
      </div>
    </article>
  );
}

export default AppCard;
